import api from "../../api/axios";

const userLogout = async (username) => {
  try {
    await api.get(`/api/users/${username}/logout`);

    return true;
  } catch (error) {
    console.error("logout failed", error);
    return false;
  }
};

export default {
  userLogout,
};
